<template>
  <v-menu bottom left>
    <template #activator="{ on, attrs }">
      <v-btn dark icon v-bind="attrs" small @click="launchStep" v-on="on">
        <v-badge
          :value="badgeValue"
          color="red"
          offset-x="10px"
          offset-y="10px"
        >
          <template #badge>
            <v-progress-circular
              v-if="loadingRecentOrders"
              indeterminate
              color="white"
              size="8"
              width="2"
              style="transform: translateY(-1px)"
            />
            <span v-else>{{ remindersCountString }}</span>
          </template>

          <v-img
            width="25px"
            height="25px"
            contain
            src="@/assets/img/navbar_icons/cart-icon.svg"
          />
        </v-badge>
      </v-btn>
    </template>

    <v-card v-if="message">
      <v-card-text>
        {{ message }}
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'RecentOrdersStepLauncher',

    computed: {
      ...mapGetters('recentOrders', [
        'hasUnprocessedRecentOrders',
        'unprocessedRecentOrdersCount',
        'loadingRecentOrders',
        'recentOrdersError',
      ]),

      remindersCountString() {
        return this.unprocessedRecentOrdersCount !== null &&
          this.unprocessedRecentOrdersCount !== undefined
          ? this.unprocessedRecentOrdersCount.toString()
          : '0';
      },

      badgeValue() {
        // If unprocessedRecentOrdersCount is 0, the badge stays hidden — so during loading, the loader isn't shown either.
        if (this.loadingRecentOrders) return 1;
        return this.unprocessedRecentOrdersCount;
      },

      message() {
        if (this.loadingRecentOrders) return 'Cargando carritos...';
        if (this.recentOrdersError) return this.recentOrdersError;
        if (!this.hasUnprocessedRecentOrders)
          return 'No tienes carritos por procesar';

        return null;
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    methods: {
      ...mapActions('modalStepsAfterLogin', [
        'updateModalState',
        'findStepByKey',
        'changeCurrentStepValue',
        'updateStepStatus',
        'loadRecentOrdersStep',
      ]),

      async launchStep() {
        if (this.hasUnprocessedRecentOrders) {
          await this.loadRecentOrdersStep();

          const reminderStep = await this.findStepByKey('recentOrders');

          if (reminderStep) {
            reminderStep.visited = true;
            this.updateStepStatus(reminderStep);
            this.changeCurrentStepValue(reminderStep.value);
            this.updateModalState(true);
          }
        }
      },
    },
  };
</script>
